<!-- @format -->

<p class="hmf-header-bold-l hmf-mb-s no-matches-found">
	<span>No matches found</span>
	@if (categoryName()) {
		<span> in {{ categoryName() }}</span>
	}.
</p>
<p class="more-info-text hmf-subheader-s hmf-mb-s">
	Please clear the filters below or change your store location for more options.
</p>
<p class="hmf-header-bold-s">Remove filters to view products:</p>
<div class="filter-chip-container">
	<plp-components-filter-chips
		[wrapChips]="true"
		class="hmf-display-flex hmf-flex-wrap"></plp-components-filter-chips>
</div>
